import './types'

/*==================================
  共通処理
===================================*/
/*  ===== エラークラスチェック ===== */
/**
 * 指定の name がエラー対象か判定する関数
 *
 * @param {string} name - Input/select の name 属性値
 * @param {object} errorClient - Errors.client オブジェクト
 * @returns {boolean} エラー対象なら true
 */
export function hasErrorClass(name, clientError) {
  if (!clientError) return false
  return Object.values(clientError).some(({ targets }) => targets?.includes(name))
}

/**
 * オブジェクトキー存在チェック
 *
 * @param {object} errors - チェック対象のオブジェクト
 * @returns {boolean} オブジェクトにキーが存在する場合は true
 */
export function hasErrors(errors) {
  if (!errors || typeof errors !== 'object') return false
  return Object.keys(errors).length > 0
}

/**
 * キャメルケースをスネークケースに変換する
 *
 * @param {string} str - キャメルケースの文字列
 * @returns {string} スネークケースに変換した文字列
 */
function toSnakeCase(str) {
  return str.replace(/([A-Z])/g, (letter) => `_${letter.toLowerCase()}`)
}

/**
 * オブジェクトのキーを再帰的にスネークケースに変換する
 *
 * @param {object | array} obj - 変換対象のオブジェクトまたは配列
 * @returns {object | array} キーがスネークケースに変換された新しいオブジェクトまたは配列
 */
export function keysToSnakeCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((v) => keysToSnakeCase(v))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [toSnakeCase(key), keysToSnakeCase(value)]))
  }
  return obj
}
